Vue.component('import-leads', {
    props: ['clients'],

    data () {
        return {
            stage: 'where',

            working: false,

            alert: null,

            type: null,

            whoForm: {
                status: null,
                client: null,
                admin: null
            },

            file: null,

            uploadProgress: 0,

            dates: {
                first_contacted: '',
                last_contacted: ''
            },

            map: {
                first_name: '',
                last_name: '',
                contact_name: '',
                contact_email: '',
                contact_email_2: '',
                contact_telephone: '',
                contact_mobile: '',
                contact_company: '',
                job_title: '',
                contact_country: '',
                contact_region: '',
                contact_type: '',
                contact_industry: '',
                linkedin: '',
                facebook: '',
                website: '',
                opt_in: '',
                twitter: '',
                notes: '',
                first_contacted: '',
                last_contacted: '',
                quote_details: '',
                lead_source: '',
                premises: '',
                order_size: '',
                address_1: '',
                address_2: '',
                city: '',
                post_code: '',
                employees: '',
                brand: '',
                dimension_a: '',
                dimension_b: '',
                dimension_c: '',
                sold: '',
                closet: '',
                attic: '',
                attic_type: '',
                zone: '',
                interested_in: '',
                dash_id: '',
            }
        };
    },

    methods: {
        setType (type) {
            this.type = type;

            if (type === 'leads') {
                this.goToStage('who');
            } else {
                this.goToStage('file');
            }
        },

        goToStage (stage) {
            this.stage = stage;
        },

        upload() {
            this.working = true;
            this.alert = null;

            axios.post('/api/import/upload', {
                file: this.file
            }, {
                headers: {
                    'Content-Type': undefined,
                },
                transformRequest (data) {
                    const formData = new FormData();

                    formData.append('file', data.file);

                    return formData;
                }, onUploadProgress: (progressEvent) => {
                    this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                }
            }).then((response) => {
                this.headers = response.data.headers;
                this.goToStage('map');
            }).catch((errors) => {
                this.alert = {
                    type: "error",
                    message: errors.response.data.message,
                    errors: errors.response.data.errors
                };
            }).then(() => {
                this.working = false;
            });
        },

        doImport () {
            this.working = true;
            this.alert = null;

            axios.post('/api/import/import', {
                map: this.map,
                dates: this.dates,
                type: this.type,
                ...this.whoForm
            }).then((response) => {
                this.goToStage('complete');
            }).catch((errors) => {
                this.alert = {
                    type: "error",
                    message: errors.response.data.message,
                    errors: errors.response.data.errors
                };
            }).then(() => {
                this.working = false;
            });
        },

        handleFileSelected (e) {
            this.file = e.target.files[0];
        }
    },

    computed: {
        formCompleted () {
            for (let field in this.whoForm) {
                if (this.whoForm[field] == null) {
                    return false;
                }
            }

            return true;
        }
    }
});